module.exports = __webpack_public_path__ + "static/media/path3.a70167ea.png";